import {request} from './request'

export function gethome(name,pagename,page){
  return request({
    method: "GET",
    url:'api/vrinfo/',
    params:{
      name,
      pagename,
      page
    }
  })
}
